// extracted by mini-css-extract-plugin
export default {"empty":"style_empty__G1x8n"};